import React from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { CircularProgress } from "@mui/material";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  text?: string;
}

const LoaderWithText: React.FC<PopupProps> = ({ isOpen, onClose, text }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      slotProps={{
        backdrop: {
          sx: {
            zIndex: 99999, // Backdrop z-index (one less than modal)
          }
        }
      }}
      sx={{
        zIndex: 100000, // Higher than DraggableResizablePopup (99999) to show above popups
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "100vw",
          height: "100vh",
          padding: "20px 30px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {text && <div>text</div>}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: "20px",
            }}
          >
            <CircularProgress size='30px' />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default LoaderWithText;
